import { Routes, Route } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import { Nav } from "./components/Nav";
import { Dashboard } from "./pages/Dashboard";
import { DailyLog } from "./pages/DailyLog";
import { Weekly } from "./pages/Weekly";
import { Labs } from "./pages/Labs";
import { Finance } from "./pages/Finance";
import { Budget } from "./pages/Budget";
import { Plan } from "./pages/Plan";
import { Login } from "./pages/Login";

function Shell() {
  const { email, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-dvh flex items-center justify-center text-muted">
        Loading...
      </div>
    );
  }

  if (!email) return <Login />;

  return (
    <div>
      <Nav />
      <main className="max-w-5xl mx-auto px-4 py-5 sm:py-6">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/log" element={<DailyLog />} />
          <Route path="/weekly" element={<Weekly />} />
          <Route path="/labs" element={<Labs />} />
          <Route path="/finance" element={<Finance />} />
          <Route path="/budget" element={<Budget />} />
          <Route path="/plan" element={<Plan />} />
        </Routes>
      </main>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Shell />
    </AuthProvider>
  );
}
